import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageHeader, TWTabNav } from '../../../components/ui';

// The admin's one Finance page (spec 2026-09-24): a header, five tabs, and
// the tab in the URL so a refresh and a shared link land on the same one.
// finance-section.js reads ?tab for restaurant roles only (its legacyTab is
// gated on !isAdmin), so the admin console can carry the same parameter.
export const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'revenue', label: 'Revenue' },
  { id: 'connect', label: 'Connect' },
  // The two legacy surfaces last, and named so (owner, 2026-09-24): they
  // are about the Mercury era, not the platform. Ids stay `payouts` and
  // `ledger`, so every URL, redirect and link keeps working.
  { id: 'payouts', label: 'Legacy Payouts' },
  { id: 'ledger', label: 'Legacy Ledger' },
];
export const TAB_PARAM = 'tab';
const DEFAULT_TAB = 'overview';

const isTab = (id) => TABS.some((t) => t.id === id);

const AdminFinance = ({ bodies }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get(TAB_PARAM);
  const current = isTab(requested) ? requested : DEFAULT_TAB;

  // A tab's body mounts the first time it opens and stays mounted, hidden,
  // so switching back never re-reads (spec "Loading and errors").
  const [opened, setOpened] = useState(() => new Set([current]));
  if (!opened.has(current)) setOpened((prev) => new Set(prev).add(current));

  const select = (id) => {
    const next = new URLSearchParams(searchParams);
    if (id === DEFAULT_TAB) next.delete(TAB_PARAM);
    else next.set(TAB_PARAM, id);
    setSearchParams(next, { replace: false });
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-white px-4 py-6 dark:bg-slate-900/40 sm:px-6 lg:px-8 lg:py-8">
      <div className="mx-auto max-w-6xl space-y-6">
        <PageHeader
          title="Finance"
          description="Where the platform's money is: what it earned, what Mercury still owes, and how every Stripe account is doing."
        />
        <TWTabNav tabs={TABS} value={current} onChange={select} ariaLabel="Finance sections" />
        {TABS.filter((t) => opened.has(t.id)).map((t) => (
          <div key={t.id} role="tabpanel" hidden={t.id !== current} aria-label={t.label}>
            {bodies?.[t.id] ?? null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminFinance;
